import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import UseTitle from "../../components/useTitle";
import "./Characters.scss";

const Characters = () => {
  // Définition du titre de la page
  UseTitle("Liste des personnages");

  const [listCharacters, setListCharacters] = useState([]);
  const [listInfos, setListInfos] = useState([]);

  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const [search, setSearch] = useState("");
  const [ordering, setOrdering] = useState("name");
  const [pageSize, setPageSize] = useState(12);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();

  const handlePageChange = (newPage) => setPage(newPage);

  useEffect(() => {
    const fetchCharacters = async () => {
      if (listCharacters.length === 0) setIsInitialLoading(true);
      else setIsRefreshing(true);

      try {
        const response = await api.get(
          `/character/?search=${search}&ordering=${ordering}&page_size=${pageSize}&page=${page}`
        );
        setListCharacters(response.data.results);
        setListInfos(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsInitialLoading(false);
        setIsRefreshing(false);
      }
    };

    fetchCharacters();
  }, [search, ordering, pageSize, page]);

  return (
    <div className="characters list-page">
      {/* Titre de la page et bouton pour ajouter un personnage */}
      <div className="characters-title">
        <h1>Liste des personnages</h1>
        <button className="bt" onClick={() => navigate(`/character/new`)}>
          Créer un personnage
        </button>
      </div>

      {/* Filtres */}
      <div className="filters">
        <div>
          <label htmlFor="search">Rechercher </label>
          <input
            type="text"
            id="search"
            name="search"
            value={search}
            onChange={(e) => (setSearch(e.target.value), setPage(1))}
          />
        </div>
        <div>
          <label htmlFor="ordering">Trier par </label>
          <select
            id="ordering"
            name="ordering"
            value={ordering}
            onChange={(event) => setOrdering(event.target.value)}
          >
            <option value="name">Ascendant</option>
            <option value="-name">Descendant</option>
          </select>
        </div>
        <div>
          <label htmlFor="pagesize">Nombre d'affichage </label>
          <select
            id="pagesize"
            name="pagesize"
            value={pageSize}
            onChange={(event) => (setPageSize(event.target.value), setPage(1))}
          >
            <option value="6">6</option>
            <option value="12">12</option>
            <option value="24">24</option>
            <option value="48">48</option>
          </select>
        </div>
        {listCharacters.length != 0 && <h2>Personnages ({listInfos.count})</h2>}
      </div>

      {/* Chargement Initial */}
      {isInitialLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}

      {/* Chargement des personnages */}
      {!isInitialLoading &&
        (listCharacters.length === 0 ? (
          <div className="list-empty">
            <p>
              <strong>Pas de personnages</strong>
            </p>
          </div>
        ) : (
          <div className={`list-div ${isRefreshing ? "loading" : ""}`}>
            {listCharacters.map((character) => (
              <NavLink
                key={character.id}
                to={`/character/${character.id}`}
                className="list-card"
              >
                <div>
                  <strong>{character.name}</strong>{" "}
                  {character.nickname && <em>({character.nickname}) </em>}
                  <small>({character.xp} XP)</small>
                </div>
                <small>Propriétaire : {character.user_proprietary}</small>
              </NavLink>
            ))}
          </div>
        ))}

      {/* Pagination */}
      {!isInitialLoading && listCharacters.length > 0 && (
        <div className="pagination">
          <button
            className={page <= 1 ? "bt disabled" : "bt"}
            onClick={() => handlePageChange(page - 1)}
            disabled={page <= 1}
          >
            &lt;&lt;
          </button>
          <span>
            {page} / {Math.ceil(listInfos.count / pageSize)}
          </span>
          <button
            className={
              page >= Math.ceil(listInfos.count / pageSize)
                ? "bt disabled"
                : "bt"
            }
            onClick={() => handlePageChange(page + 1)}
            disabled={page >= Math.ceil(listInfos.count / pageSize)}
          >
            &gt;&gt;
          </button>
        </div>
      )}
    </div>
  );
};

export default Characters;
